import React from "react";

import "./style.scss";

const TextBtn = ({name, handleClick, disabled = false}) => {
  return (
    <button
      type="button"
      className={`text-button ${disabled ? "text-disabled-btn" : ""}`}
      onClick={() => {
        handleClick();
      }}
      disabled={disabled}
    >
      {name}
    </button>
  );
};

export default TextBtn;
